<template>
    <div class="header__menu" v-for="(item, index) in result.menusMenus.data" v-if="result">

        <div v-for="(menuItem, index) in item.attributes.items.data">

            <router-link    v-if="menuItem.attributes.target != 'blank'"
                            class="header__menu__item"
                            :to="menuItem.attributes.url">
                            <span class="underline-text">
                                {{menuItem.attributes.title}}
                            </span>
            </router-link>

            <a v-else :href="menuItem.attributes.url" class="header__menu__item" target="_blank">
                <span class="underline-text">
                    {{menuItem.attributes.title}}
                </span>
            </a>

        </div>

    </div>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue'

import { useQuery } from '@vue/apollo-composable'
import { MAIN_MENU_QUERY } from '../../graphql/main-menu'

export default defineComponent({
    setup() {
        const homeurl: string = import.meta.env.VITE_API_URL

        const query = ref(MAIN_MENU_QUERY)

        const { result } = useQuery(query)


        return {
            result,
            homeurl
        }
    }
})

</script>
